export const iconFontAwesomeEmojiFaceTired = (
	<i className="fa-solid fa-face-tired"></i>
);
